import { createAction } from 'redux-actions';

import dynaForms from '@elab/core/utils/dynaForms';

import { getTypes } from './types';

export const getActions = storeName => {
    const types = getTypes(storeName);

    return {
        ...dynaForms.getActions(storeName),
        cancel: createAction(types.CANCEL),
        reset: createAction(types.RESET),
    };
};
